export const getResponsiveClasses = (length: number) => {
  const config = {
    1: {
      grid: 'grid-cols-2 sm:grid-cols-1',
      countersContainer: 'sm:col-span-full',
      countersContent: 'flex-col items-start'
    },
    2: {
      grid: 'grid-cols-3 lg:grid-cols-2',
      countersContainer: 'lg:col-span-full sm:mr-24 xs:mr-16',
      countersContent: 'flex-col items-start lg:flex-row lg:items-center'
    },
    3: {
      grid: 'grid-cols-3',
      countersContainer: 'col-span-full xs:mr-16',
      countersContent: 'flex-row items-center'
    }
  }

  return (
    config[length as keyof typeof config] || {
      grid: '',
      countersContainer: '',
      countersContent: 'h-[187px]'
    }
  )
}
